import { useEffect } from "react";
import { useRef } from "react";
import { IoIosArrowDown } from "react-icons/io"

export default function SelectColumns({tableConfigIsOpen, headersOptions, setTableValues}){
    const selectColumns = useRef(null);
    
    function handleCheckboxChange(headerIndexInCheckbox){
        headersOptions?.setState(headersOptions?.state.map((headerOption, index) => {
            if(index === headerIndexInCheckbox){
                headerOption.isSelected = !headerOption.isSelected;
            }

            return headerOption;
        }))

        setTableValues();
    }

    function onClickOutside(event){
        if(!event.target || !selectColumns?.current?.contains(event.target)){
            tableConfigIsOpen?.setState(false);
        }
    }

    useEffect(() => {
        document.addEventListener("click", onClickOutside);
        
        return () => {
            document.removeEventListener("click", onClickOutside);
        }
    }, []);

    return (
        <div className="table-config" ref={selectColumns}>
            <div className="table-config__header" onClick={() => tableConfigIsOpen?.setState(!tableConfigIsOpen?.state)}>
                <h2 className="table-config___label">Selecione as colunas</h2>
                <IoIosArrowDown style={{fontSize: "1rem"}} />
            </div>
            <ul className="table-config__options" style={{display: `${tableConfigIsOpen?.state ? "inherit" : "none"}`}}>
                {headersOptions?.state.map((headerOption, index) => {
                    return (
                        <li className="table-config___option" key={index}>
                            <input 
                                type="checkbox" 
                                className="table-config____option-checkbox" 
                                onChange={() => handleCheckboxChange(index)} 
                                checked={headerOption?.isSelected} 
                            />
                            <h3 className="table-config____option-label">{headerOption.label}</h3>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}